import { render, staticRenderFns } from "./FlagsIndicatorSelectedComponent.vue?vue&type=template&id=2b085470&scoped=true"
import script from "./FlagsIndicatorSelectedComponent.vue?vue&type=script&lang=js"
export * from "./FlagsIndicatorSelectedComponent.vue?vue&type=script&lang=js"
import style0 from "./FlagsIndicatorSelectedComponent.vue?vue&type=style&index=0&id=2b085470&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b085470",
  null
  
)

export default component.exports